import ajax from '@/utils/ajax';

const head = '/web';

// 获取用户收货地址列表
export const reqAddressList = (data) => ajax(`${head}/v1/user/address/list?pageNum=${data.pageNum}&pageSize=${data.pageSize}`);

// 获取待发货讲义信息
export const reqOrderAddressList = (data) => ajax(`${head}/v1/logistics/front/wait-deliver-info`);

// 取消默认地址
export const reqCancelDefault = (data) => ajax(`${head}/v1/user/address/cancel-default/${data}`, data, 'PUT');

// 设置默认地址
export const reqSetDefault = (data) => ajax(`${head}/v1/user/address/set-default/${data}`, data, 'PUT');

// 删除地址
export const reqDeleteAddress = (data) => ajax(`${head}/v1/user/address/delete/${data}`, '', 'DELETE');

// 获取全国地区三级联动列表
export const reqTerritoryList = (data) => ajax(`${head}/v1/user/address/territory/list?id=${data}`);

// 添加用户收货地址
export const reqAddAddress = (data) => ajax(`${head}/v1/user/address/add-address`, data, 'POST');

// 收货地址信息
export const reqAddressInfo = (data) => ajax(`${head}/v1/user/address/info/${data}`, data);

// 修改收货地址
export const reqModifyAddress = (data) => ajax(`${head}/v1/user/address/modify-address`, data, 'PUT');

// 活动 - 打卡活动新增地址
export const reqAddDakaAddress = (data) => ajax(`${head}/v1/daka/activity/save-address`, data, 'POST');

// 活动 - 打卡活动新增地址
export const reqAddPullNewAddress = (data) => ajax(`${head}/v1/daka/activity/save-address`, data, 'POST');
